module.exports = {
  initSlide (direction, index) {
    // console.log(index)
    var initalSliderID = document.getElementById('sec-' + index)
    // console.log(initalSliderID)
    // var clickedItem = event.target
    // var initalSlider = els
    // var clickedID = event.target.closest('.imageSlider').getAttribute('id')
    // var initalSlider = clickedItem.closest('.imageSlider')
    // var initalSliderID = initalSlider.getAttribute('id')
    // initalSliderID = document.getElementById(initalSliderID)
    // console.log(initalSliderID)
    var slides = initalSliderID.querySelectorAll('.slide')
    // console.log(slides)
    var thumbs = initalSliderID.querySelectorAll('.thumb')
    // var texts = initalSliderID.querySelectorAll('.slide-text')
    var nextBtn = initalSliderID.querySelectorAll('.swiper-button-next')
    // console.log(nextBtn)
    var prevBtn = initalSliderID.querySelectorAll('.swiper-button-prev')
    // console.log(prevBtn)
    var maxSlides = slides.length
    maxSlides = maxSlides - 1
    var lastThumb = initalSliderID.querySelectorAll('.thumbs')[0].lastChild
    var firstThumb = initalSliderID.querySelectorAll('.thumbs')[0].firstChild
    var activeID = ''
    var activeEle = ''
    var activeThumb = ''
    var nextEle = ''
    var nextID = ''
    var prevEle = ''
    var prevID = ''
    var clickDirection = direction
    var nextThumb = ''
    var prevThumb = ''

    for (var i = 0; i < slides.length; i++) {
      if (slides[i].classList.contains('active')) {
        // check if class active exists
        activeID = slides[i].id
        activeEle = slides[i]

        // targeting inital active thumb and finding next and previous
        for (var t = 0; t < thumbs.length; t++) {
          if (thumbs[t].classList.contains('active')) {
            var activeThumbID = thumbs[t].id
            activeThumb = thumbs[t]
            // console.log(activeThumb)
            // Get the Next sibling Thumb and Previous sibling thumb Element
            // make sure next thumb exists
            if (activeThumbID === lastThumb.id) {
              nextThumb = initalSliderID.querySelectorAll('.thumbs')[0].firstChild
              prevThumb = activeThumb.previousElementSibling
            } else if (activeThumbID === firstThumb.id) {
              nextThumb = activeThumb.nextElementSibling
              prevThumb = initalSliderID.querySelectorAll('.thumbs')[0].lastChild
            } else {
              nextThumb = activeThumb.nextElementSibling
              prevThumb = activeThumb.previousElementSibling
            }
          }
        }

        if (clickDirection === 'next') {
          // console.log('next')
          // IF YOU'RE GOING TO THE NEXT SLIDE
          // 1. Setting button styles depending on what the active index it
          // 2. Finding the 'nextID'
          // 3. sliding to next humb
          // 4. Finding the next Slide
          // 5. Main slide animation
          // 6. Next slide animation

          // 1
          prevBtn[0].style.opacity = '1'
          nextID = Number(activeID) + 1
          // console.log(nextID)
          // console.log('max slides = ' + maxSlides)
          // 2
          if (nextID > maxSlides) {
            nextBtn[0].style.opacity = '0.3'
            return
          } else {
            nextBtn[0].style.opacity = '1'
          }
          // 3
          window.Velocity(activeThumb, { left: '100%' }, { duration: 900,
            complete: function () {
              activeThumb.classList.remove('active')
            }
          })
          window.Velocity(nextThumb, { left: '0px' }, { duration: 900,
            complete: function () {
              nextThumb.classList.add('active')
            }
          })
          // 4
          nextID = String(nextID)
          nextEle = slides[nextID]
          // console.log(activeEle)
          // 5
          window.Velocity(activeEle, { left: '100%' }, { duration: 900,
            complete: function (activeEle) {
              var activeSlide = activeEle
              for (var h = 0; h < activeSlide.length; h++) {
                // console.log('INside' + activeSlide[h])
                // loop through prev
                var prevElements = initalSliderID.querySelectorAll('.slide')
                for (var j = 0; j < prevElements.length; j++) {
                  if (prevElements[j].classList.contains('prev')) {
                    prevElements[j].classList.remove('prev')
                  }
                }

                activeSlide[h].classList.add('prev')
                activeSlide[h].classList.remove('active')
              }

              var textElments = initalSliderID.querySelectorAll('.slide-text.active')
              for (var p = 0; p < textElments.length; p++) {
                textElments[p].nextElementSibling.classList.add('active')
                textElments[p].classList.remove('active')
              }
            }
          })
          // 6
          window.Velocity(nextEle, { left: '0px' }, { duration: 900,
            complete: function () {
              nextEle.classList.remove('next')
              nextEle.classList.add('active')
              if (nextEle.nextElementSibling !== null) {
                nextEle.nextElementSibling.classList.add('next')
              }
            }
          })
          if (nextID >= maxSlides) {
            nextBtn[0].style.opacity = '0.3'
            return
          }
        } else {
          // console.log('prev')
          // IF YOU'RE GOING TO THE PREV SLIDE
          // 1. Setting button styles depending on what the active index it
          // 2. Finding the 'PREVID'
          // 3. Animating thumbs prev slide
          // 4. Finding the next Slide
          // 5. Main slide animation
          // 6. PREV slide animation

          var textElments = initalSliderID.querySelectorAll('.slide-text.active')
          for (var p = 0; p < textElments.length; p++) {
            textElments[p].previousElementSibling.classList.add('active')
            textElments[p].classList.remove('active')
          }

          // 1
          nextBtn[0].style.opacity = '1'
          prevID = Number(activeID) - 1
          // 2
          if (prevID < 0) {
            prevBtn[0].style.opacity = '0.3'
            return
          } else {
            prevBtn[0].style.opacity = '1'
          }
          // 3
          window.Velocity(activeThumb, { left: '-100%' }, { duration: 900,
            complete: function () {
              activeThumb.classList.remove('active')
            }
          })
          window.Velocity(prevThumb, { left: '0px' }, { duration: 900,
            complete: function () {
              prevThumb.classList.add('active')
            }
          })
          // 4
          prevID = String(prevID)
          prevEle = slides[prevID]
          // 5
          window.Velocity(activeEle, { left: '-100%' }, { duration: 900,
            complete: function () {
              var prevElements = initalSliderID.querySelectorAll('.slide')
              for (var j = 0; j < prevElements.length; j++) {
                if (prevElements[j].classList.contains('prev')) {
                  activeEle.previousElementSibling.classList.remove('next')
                }
              }
              if (activeEle.nextElementSibling !== null) {
                activeEle.nextElementSibling.classList.remove('next')
              }
              activeEle.classList.add('next')
              activeEle.classList.remove('active')
            }
          })
          // 6
          window.Velocity(prevEle, { left: '0px' }, { duration: 900,
            complete: function () {
              prevEle.classList.remove('prev')
              prevEle.classList.remove('next')
              prevEle.classList.add('active')
              if (prevEle.previousElementSibling !== null) {
                prevEle.previousElementSibling.classList.add('prev')
              }
            }
          })
          if (prevID <= 0) {
            prevBtn[0].style.opacity = '0.3'
            return
          }
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/projectSlider.js